import { useObjectMemo } from "@contember/react-utils";
import { useMemo } from "react";
import { SingleKindFileHandler, isEmptyByUrlField } from "./SingleKindFileHandler.js";
const useSingleKindFileHandler = (props, kindFactory) => {
  const stableProps = useObjectMemo(props);
  return useMemo(
    () => new SingleKindFileHandler(
      kindFactory(stableProps),
      isEmptyByUrlField(stableProps.urlField)
    ),
    [kindFactory, stableProps]
  );
};
export {
  useSingleKindFileHandler
};
//# sourceMappingURL=useSingleKindFileHandler.js.map
